import BarChart, { generateEmptyPlaceHolder } from 'components/BarChart';
import { useRouter } from 'next/router';
import { useGetEventAnalyticsTicketScanByTier } from 'legacy/events/hooks/useGetEventAnalyticsTicketScanByTier';
import {
  EventAnalyticsTicketScansByTierDto,
  EventAnalyticsTicketTiersDataPointDto,
  EventAnalyticsTicketScansByTierDataPointDto
} from 'legacy/events/types';
import Loader from 'legacy/common/components/layout/Loader';

const REVENUE_DAYS_DEFAULT = 5;

const TicketTiersScannedBarGraph = () => {
  const router = useRouter();

  const eventId = router.query.slug as string;
  const { data: ticketScansByTier, isLoading } =
    useGetEventAnalyticsTicketScanByTier({
      eventId
    });

  const generateTicketTiersGraphData = (
    data:
      | EventAnalyticsTicketScansByTierDto[]
      | EventAnalyticsTicketTiersDataPointDto[]
      | EventAnalyticsTicketScansByTierDataPointDto[]
  ) => {
    const groupBy = (data: any[], key: string) =>
      data?.reduce((acc, item) => {
        acc[item[key]] = acc[item[key]] || [];
        acc[item[key]].push(item);
        return acc;
      }, {});

    const ticketTiersScannedData = Object.entries(
      groupBy(data, 'tierName')
    ).map(([name, items]) => {
      const typedItems = items as EventAnalyticsTicketScansByTierDataPointDto[];

      return {
        name: name.replace(' - ', ' '),
        value: typedItems.reduce((acc, item) => acc + item.ticketsScanned, 0),
        total: typedItems.reduce((acc, item) => acc + item?.ticketsSold, 0)
      };
    });

    return ticketTiersScannedData;
  };

  if (isLoading) {
    return <Loader isLoading />;
  }

  let ticketTiersScanned =
    ticketScansByTier?.data?.length > 0
      ? generateTicketTiersGraphData(ticketScansByTier.data)
      : [];

  // for empty state
  if (ticketTiersScanned.length === 0) {
    ticketTiersScanned = [
      generateEmptyPlaceHolder('-', 0, 0),
      generateEmptyPlaceHolder('-', 0, 0),
      generateEmptyPlaceHolder('-', 0, 0),
      generateEmptyPlaceHolder('-', 0, 0),
      generateEmptyPlaceHolder('-', 0, 0)
    ];
  }

  return (
    <BarChart
      data={ticketTiersScanned}
      className="w-1/2"
      title={`Top ${
        ticketScansByTier?.data?.length &&
        ticketScansByTier.data.length >= REVENUE_DAYS_DEFAULT
          ? ticketScansByTier.data.length
          : ''
      } Ticket Tiers Scanned`}
      type="number"
    />
  );
};

export default TicketTiersScannedBarGraph;
